import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function Hero() {
  return <section id="home" className="relative min-h-[90vh] flex items-center pt-20 pb-16 md:pt-28 md:pb-24" data-id="element-105">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-106">
        <img src="https://cdn.magicpatterns.com/uploads/1FbXKoJCVxnB7YzAE8ez7o/yei1.png" alt="Beautiful San Diego landscaping" className="w-full h-full object-cover object-center" data-id="element-107" />
        <div className="absolute inset-0 bg-black/60" data-id="element-108"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-109">
        <div className="max-w-3xl" data-id="element-110">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-111">
            <span className="inline-block text-accent font-bold tracking-wider text-sm md:text-base mb-4 uppercase" data-id="element-112">
              SAN DIEGO COUNTY'S TRUSTED LANDSCAPING TEAM
            </span>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-6" data-id="element-113">
              Your Yard Deserves More Than A Promise.
            </h1>

            <p className="text-lg md:text-xl text-gray-200 mb-10 max-w-2xl leading-relaxed" data-id="element-114">
              Professional Landscaping, Hardscape, Tree Trimming, Pavers,
              Irrigation & More — One Reliable Team. Serving All of San Diego
              County.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-8" data-id="element-115">
              <a href="#contact" className="bg-primary hover:bg-primary/90 text-white font-bold py-4 px-8 rounded-md text-center transition-colors text-lg" data-id="element-116">
                GET YOUR FREE ESTIMATE
              </a>
              <a href="tel:6192492966" className="bg-transparent border-2 border-white hover:bg-white/10 text-white font-bold py-4 px-8 rounded-md text-center transition-colors text-lg" data-id="element-117">
                CALL (619) 249-2966
              </a>
            </div>

            <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-gray-300" data-id="element-118">
              <div className="flex items-center gap-1.5" data-id="element-119">
                <CheckCircle2 size={16} className="text-accent" data-id="element-120" />
                <span data-id="element-121">No Cost</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-122">
                <CheckCircle2 size={16} className="text-accent" data-id="element-123" />
                <span data-id="element-124">No Commitment</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-125">
                <CheckCircle2 size={16} className="text-accent" data-id="element-126" />
                <span data-id="element-127">Fast Response</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-128">
                <CheckCircle2 size={16} className="text-accent" data-id="element-129" />
                <span data-id="element-130">Local Team</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}